export default function DrawdownEnvelopeCardMock() {
  // Mini envelope SVG: P5/P95 bands with observed line
  const w = 260;
  const h = 50;

  return (
    <div className="platform-mock mock-sidebar">
      <div className="platform-mock-header"><span className="dot" style={{ background: '#f97316' }} /> Drawdown Envelope</div>
      <div className="platform-mock-body" style={{ padding: '1rem 1.25rem' }}>
        <div style={{ fontSize: '0.8125rem', fontWeight: 600, color: '#e5e7eb', marginBottom: '0.5rem' }}>
          Observed vs Simulated
        </div>

        {/* Envelope chart */}
        <svg viewBox={`0 0 ${w} ${h}`} style={{ width: '100%', height: 50, marginBottom: '0.5rem' }}>
          {/* P5-P95 band */}
          <path
            d={`M0,${h} L30,${h - 5} L60,${h - 12} L100,${h - 22} L140,${h - 30} L180,${h - 35} L220,${h - 38} L${w},${h - 40}
                L${w},${h - 15} L220,${h - 14} L180,${h - 12} L140,${h - 10} L100,${h - 8} L60,${h - 4} L30,${h - 2} L0,${h} Z`}
            fill="#f97316"
            opacity="0.12"
          />
          {/* P50 median */}
          <path
            d={`M0,${h} L30,${h - 3} L60,${h - 7} L100,${h - 14} L140,${h - 19} L180,${h - 22} L220,${h - 25} L${w},${h - 27}`}
            fill="none" stroke="#f97316" strokeWidth="1" strokeDasharray="3,2" opacity="0.5"
          />
          {/* Observed line */}
          <path
            d={`M0,${h} L30,${h - 4} L60,${h - 9} L100,${h - 16} L140,${h - 20} L180,${h - 24} L220,${h - 26} L${w},${h - 26}`}
            fill="none" stroke="#e5e7eb" strokeWidth="1.5"
          />
        </svg>
        <div style={{ display: 'flex', gap: 12, fontSize: '0.5625rem', color: '#6b7280', marginBottom: '0.75rem' }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <span style={{ width: 12, height: 2, background: '#e5e7eb', display: 'inline-block' }} /> Observed
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <span style={{ width: 12, height: 6, background: '#f97316', opacity: 0.2, display: 'inline-block', borderRadius: 1 }} /> P5–P95
          </span>
        </div>

        {/* Percentile position */}
        <div style={{
          fontSize: '0.5625rem',
          fontWeight: 700,
          color: '#6b7280',
          textTransform: 'uppercase',
          letterSpacing: '0.08em',
          marginBottom: '0.25rem',
        }}>
          Percentile Position
        </div>
        <div style={{ position: 'relative', height: 12, background: '#1f2937', borderRadius: 6, marginBottom: 4, overflow: 'hidden' }}>
          <div style={{ position: 'absolute', left: 0, top: 0, width: '64%', height: '100%', background: 'linear-gradient(90deg, #f97316 0%, #fb923c 100%)', borderRadius: 6 }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.5625rem', color: '#6b7280' }}>
          <span>P5</span>
          <span style={{ color: '#f97316', fontWeight: 700 }}>64th percentile</span>
          <span>P95</span>
        </div>
      </div>
      <div className="platform-mock-caption">
        Drawdown Envelope uses Monte Carlo simulation to show whether observed drawdown is typical or an outlier.
      </div>
    </div>
  );
}
